<template>
  <div class="content-dashboard">
    <div v-if="mode === 'simple'">
      <form @submit.prevent="saveChanges">
        <div class="d-flex align-items-center justify-content-between">
          <h3>Mes informations personnelles</h3>
          <button type="button" class="btn btn-outline-orange" @click="toggleEdit" :disabled="registerStore.loading" v-if="!isDelegue">
            {{ registerStore.isEditingClient ? "Annuler" : "Modifier" }}
          </button>
        </div>
        <div v-if="registerStore.error" class="alert alert-danger mt-3">
          {{ registerStore.error }}
        </div>
        <div v-if="registerStore.loading" class="text-center mt-3">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Chargement...</span>
          </div>
        </div>
        <div class="row mt-3" v-else>
          <div class="col-lg-12">
            <h4 class="font-18 font-bold mb-3">Informations générales</h4>
            <div class="box-chart mb-3 w-100 p-5" v-if="!isDelegue">
              <div class="row mt-3">
                <div class="col-lg-6">
                  <div class="form-input">
                    <label for="civilite">Civilité:</label>
                    <select
                      id="civilite"
                      class="form-select"
                      v-model="form.civilite"
                      :disabled="!registerStore.isEditingClient"
                    >
                      <option value="">Choisissez une civilité</option>
                      <option v-for="gender in GENDERS" :key="gender.code" :value="gender.code">
                        {{ gender.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6">
                  <div class="form-input">
                    <label for="nom">Nom:</label>
                    <input
                      type="text"
                      class="form-control"
                      id="nom"
                      v-model="form.nom"
                      :disabled="!registerStore.isEditingClient"
                      required
                    />
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-input">
                    <label for="prenom">Prénom:</label>
                    <input
                      type="text"
                      class="form-control"
                      id="prenom"
                      v-model="form.prenom"
                      :disabled="!registerStore.isEditingClient"
                      required
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6">
                  <div class="form-input">
                    <label for="email">Email:</label>
                    <input
                      type="email"
                      class="form-control"
                      id="email"
                      v-model="form.email"
                      :disabled="!registerStore.isEditingClient"
                      required
                    />
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-input">
                    <label for="emailConfirm">Confirmation Email:</label>
                    <input
                      type="email"
                      class="form-control"
                      id="emailConfirm"
                      v-model="form.emailConfirm"
                      :disabled="!registerStore.isEditingClient"
                      required
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6">
                  <div class="form-input">
                    <label for="adresse">Adresse:</label>
                    <input
                      type="text"
                      class="form-control"
                      id="adresse"
                      v-model="form.adresse"
                      :disabled="!registerStore.isEditingClient"
                      required
                    />
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-input">
                    <label for="complement1">Complément d'adresse:</label>
                    <input
                      type="text"
                      class="form-control"
                      id="complement1"
                      v-model="form.complement1"
                      :disabled="!registerStore.isEditingClient"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6">
                  <div class="form-input">
                    <label for="complement2">Complément d'adresse 2:</label>
                    <input
                      type="text"
                      class="form-control"
                      id="complement2"
                      v-model="form.complement2"
                      :disabled="!registerStore.isEditingClient"
                    />
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-input">
                    <label for="codePostal">Code postal:</label>
                    <input
                      type="text"
                      class="form-control"
                      id="codePostal"
                      v-model="form.codePostal"
                      v-only-digits
                      :disabled="!registerStore.isEditingClient"
                      required
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6">
                  <div class="form-input">
                    <label for="ville">Ville:</label>
                    <input
                      type="text"
                      class="form-control"
                      id="ville"
                      v-model="form.ville"
                      :disabled="!registerStore.isEditingClient"
                      required
                    />
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-input">
                    <label for="pays">Pays:</label>
                    <select
                      id="pays"
                      class="form-select"
                      v-model="form.pays"
                      :disabled="!registerStore.isEditingClient"
                      required
                    >
                      <option v-for="country in COUNTRIES" :key="country.code" :value="country.name">
                        {{ country.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6">
                  <div class="form-input">
                    <label for="telephoneFixe">Téléphone fixe:</label>
                    <div class="input-group">
                      <select
                        class="form-select telephone-select"
                        v-model="form.indicatifPhoneNumber"
                        :disabled="!registerStore.isEditingClient"
                      >
                        <option
                          v-for="country in countryDialCodes"
                          :key="country.code"
                          :value="country.dialCode"
                        >
                          {{ country.displayCode }} {{ country.code }}
                        </option>
                      </select>
                      <input
                        type="text"
                        class="form-control telephone-input"
                        id="telephoneFixe"
                        v-model="form.telephoneFixe"
                        v-only-digits
                        :disabled="!registerStore.isEditingClient"
                      />
                    </div>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-input">
                    <label for="telephonePortable">Téléphone portable:</label>
                    <div class="input-group">
                      <select
                        class="form-select telephone-select"
                        v-model="form.indicatifCellphone"
                        :disabled="!registerStore.isEditingClient"
                      >
                        <option
                          v-for="country in countryDialCodes"
                          :key="country.code"
                          :value="country.dialCode"
                        >
                         {{ country.displayCode }} {{ country.code }}
                        </option>
                      </select>
                      <input
                        type="text"
                        class="form-control telephone-input"
                        id="telephonePortable"
                        v-model="form.telephonePortable"
                        v-only-digits
                        :disabled="!registerStore.isEditingClient"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="row justify-content-center mt-4">
                <div class="col-lg-3">
                  <button
                    type="submit"
                    class="btn btn-orange w-100"
                    :disabled="!registerStore.isEditingClient || registerStore.loading"
                  >
                    {{ registerStore.loading ? "Enregistrement..." : "Enregistrer" }}
                  </button>
                </div>
              </div>
            </div>

            <div class="delegue-informations mb-2" v-else>
              <p>Bonjour {{ form.prenom }} {{ form.nom }}, vous pouvez dés a présent effectuer une
                commande pour un de vos clients : 
              </p>
              <br>
              <p>- de manière classique via la page Acheter.</p>
              <p>- en saisire rapide via la page Panier.</p>
              <br>
              <p>Vous pouvez également modifier à tout moment votre mot de passe via le formulaire ci-dessous :</p>
            </div>

            <h4 class="font-18 font-bold mb-3" v-if="!isDelegue">Votre vétérinaire</h4>

            <div class="box-chart w-100 d-flex gap-3 mb-4 p-5" v-if="!isDelegue">
              <div class="d-flex justify-content-between align-items-start w-100">
                <div>
                  <strong class="blue-color">{{ veterinaryInfo.name || "" }}</strong>
                  <ul class="info-list mt-2">
                    <li>
                      <i class="ti ti-location-pin blue-color font-18 pe-1"></i>
                      <span>{{ veterinaryInfo.veterinary_city || "" }}</span>
                    </li>
                    <li>
                      <img :src="phone" />
                      <span>{{ veterinaryInfo.phone || "" }}</span>
                    </li>
                    <li>
                      <img :src="envelope" />
                      <span>{{ veterinaryInfo.email || "" }}</span>
                    </li>
                    <li><button 
                  type="button" 
                  class="btn btn-outline-orange align-self-start"
                  @click="openChangeVeterinarianModal"
                >
                  Modifier votre vétérinaire
                </button></li>
                  </ul>
                  
                </div>
                
              </div>
            </div>

            <h4 class="font-18 font-bold mb-3">Mon mot de passe</h4>
            <div class="box-chart w-100 p-5">
              <div class="row mt-3">
                <div class="col-lg-12">
                  <div class="form-input d-flex flex-row align-items-center gap-3 w-100">
                    <label class="label-control min-w-200px mb-0">Mot de passe</label>
                    <input type="password" class="form-control w-50" id="pwd" placeholder="............" disabled />
                    <a
                      href=""
                      @click.prevent="openChangePasswordModal"
                      class="text-orange text-decoration-none small font-weight-bold"
                      style="white-space: nowrap"
                    >
                      Changer votre mot de passe
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- Modal de changement de mot de passe -->
  <div
    class="modal"
    :class="{ show: showPasswordModal, 'd-block': showPasswordModal }"
    id="ChangePasswordModal"
    ref="changePasswordModal"
    tabindex="-1"
    aria-labelledby="modalLabel"
    :aria-hidden="!showPasswordModal"
    v-show="showPasswordModal"
    style="background-color: rgba(0, 0, 0, 0.5)"
  >
    <div class="modal-dialog modal-dialog-centered modal-width">
      <div class="modal-content">
        <div class="modal-header justify-content-end">
          <button
            type="button"
            class="close-link"
            data-bs-dismiss="modal"
            @click="closeChangePasswordModal"
            aria-label="Fermer"
          >
            <i class="ti ti-close"></i>
          </button>
        </div>
        <div class="modal-body padd-modal">
          <h3>Modification de mot de passe</h3>

          <div v-if="passwordError" class="alert alert-danger mt-3">
            {{ passwordError }}
          </div>

          <form class="mt-4" @submit.prevent="changePassword">
            <div class="d-flex gap-3">
              <div class="input-form">
                <label class="label-control">Mot de passe actuel*</label>
                <input
                  type="password"
                  class="form-control"
                  v-model="passwordForm.currentPassword"
                  required
                  :disabled="passwordLoading"
                />
              </div>
            </div>

            <div class="d-flex gap-3">
              <div class="input-form">
                <label class="label-control">Nouveau mot de passe*</label>
                <input
                  type="password"
                  class="form-control"
                  v-model="passwordForm.newPassword"
                  required
                  :disabled="passwordLoading"
                />
              </div>
              <div class="input-form">
                <label class="label-control">Confirmer le nouveau mot de passe*</label>
                <input
                  type="password"
                  class="form-control"
                  v-model="passwordForm.confirmPassword"
                  required
                  :disabled="passwordLoading"
                />
              </div>
            </div>

            <div class="d-flex justify-content-center">
              <button type="submit" class="btn btn-orange" :disabled="passwordLoading">
                {{ passwordLoading ? "Modification..." : "Confirmer" }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal pour changer le vétérinaire -->
  <div
    class="modal"
    :class="{ show: showVeterinarianModal, 'd-block': showVeterinarianModal }"
    id="ChangeVeterinarianModal"
    ref="changeVeterinarianModal"
    tabindex="-1"
    aria-labelledby="veterinarianModalLabel"
    :aria-hidden="!showVeterinarianModal"
    v-show="showVeterinarianModal"
    style="background-color: rgba(0, 0, 0, 0.5)"
  >
    <div class="modal-dialog modal-dialog-centered modal-width">
      <div class="modal-content">
        <div class="modal-header justify-content-end">
          <button
            type="button"
            class="close-link"
            data-bs-dismiss="modal"
            @click="closeChangeVeterinarianModal"
            aria-label="Fermer"
          >
            <i class="ti ti-close"></i>
          </button>
        </div>
        <div class="modal-body padd-modal">
          <h3>Changement de vétérinaire</h3>


          <div class="mt-4 text-center">
            <p class="mb-4 text-danger font-weight-bold">Vous êtes sur le point de changer votre vétérinaire !</p>
            
            <form class="mt-4" @submit.prevent="confirmChangeVeterinarian">
              <div class="d-flex justify-content-center mb-4">
                <div class="input-form" style="width: 100%; max-width: 400px;">
                  <label class="label-control">Code vétérinaire*</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="veterinarianForm.veterinaryCode"
                    placeholder="Entrez le code vétérinaire"
                    required
                    :disabled="veterinarianLoading"
                  />
                </div>
              </div>

              <!-- Checkbox de confirmation -->
              <div class="d-flex justify-content-center mb-4">
                <div class="form-check" style="max-width: 400px; text-align: left; background-color: cornsilk;">
                   <label class="form-check-label  font-weight-bold" for="confirmChange">
                    Je confirme que je souhaite changer mon vétérinaire actuel
                  </label>
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="confirmChange"
                    v-model="veterinarianForm.confirmChange"
                    :disabled="veterinarianLoading"
                  >
                 
                </div>
              </div>

              <div class="d-flex justify-content-center gap-3 mt-4">
                <button 
                  type="button" 
                  class="btn btn-outline-orange px-4" 
                  @click="closeChangeVeterinarianModal"
                  :disabled="veterinarianLoading"
                >
                  Annuler
                </button>
                <button 
                  type="submit" 
                  class="btn btn-orange px-4" 
                  :disabled="veterinarianLoading || !veterinarianForm.veterinaryCode.trim() || !veterinarianForm.confirmChange"
                >
                  {{ veterinarianLoading ? "Chargement..." : "Confirmer" }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import phone from "@/assets/images/phone.svg";
import envelope from "@/assets/images/envelope.svg";
import { useRegisterStore } from "@/stores/register";
import { COUNTRIES, GENDERS, getCountryNameByCode } from "@/config/constants";
import { useToast } from "vue-toastification";
import AuthService from '@/services/authService';
import { changeVeterinarian } from '@/api/auth';
import { useAuthStore } from '@/stores/authStore';
import { getCountryCallingCode } from "libphonenumber-js";

export default {
  name: 'InformationsPersonnelsClientView',
  setup() {
    const registerStore = useRegisterStore();
    return { registerStore };
  },
  data() {
    return {
      phone,
      envelope,
      mode: "simple",
      COUNTRIES,
      GENDERS,
      form: {
        civilite: "M.",
        nom: "",
        prenom: "",
        email: "",
        emailConfirm: "",
        adresse: "",
        complement1: "",
        complement2: "",
        codePostal: "",
        ville: "",
        pays: "France",
        telephoneFixe: "",
        telephonePortable: "",
        indicatifPhoneNumber: "33",
        indicatifCellphone: "33",
      },
      originalForm: {},
      passwordForm: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      passwordError: null,
      passwordLoading: false,
      showPasswordModal: false,
      // Nouvelles données pour le changement de vétérinaire
      showVeterinarianModal: false,
      veterinarianForm: {
        veterinaryCode: "",
        confirmChange: false
      },
      veterinarianError: null,
      veterinarianSuccess: null,
      veterinarianLoading: false,
    };
  },
  computed: {
    veterinaryInfo() {
      const clientInfo = this.registerStore.clientInfo;
      const veterinarian = clientInfo.veterinarian || {};
      const veterinarianName = clientInfo.veterinary?.lastName || {};

      const address = veterinarian.address || {};
      return {
        name: veterinarianName || "",
        veterinary_city: address.complete || "",
        phone: veterinarian.phoneNumber || "",
        email: veterinarian.email || "",
      };
    },

    isDelegue() {
      return AuthService.isDelegue();
    },
    countryDialCodes() {
      return this.COUNTRIES.map((country) => {
        try {
          const dialCode = getCountryCallingCode(country.code);
          return {
            ...country,
            dialCode: dialCode, // Just digits (e.g. "33")
            displayCode: `+${dialCode}`, // Display format (e.g. "+33")
            displayName: `${country.name} (+${dialCode})`,
          };
        } catch (error) {
          return null;
        }
      })
      .filter((c) => c)
      .sort((a, b) => a.name.localeCompare(b.name));
    },
  },
  async mounted() {
    await this.loadClientData();
  },
  methods: {
    async loadClientData() {
      await this.registerStore.fetchClientInfo();
      this.mapApiDataToForm();
    },
    mapApiDataToForm() {
      const clientInfo = this.registerStore.clientInfo;
      if (clientInfo && Object.keys(clientInfo).length > 0) {
        this.form = {
          civilite: clientInfo.gender || "u",
          nom: clientInfo.lastName || "",
          prenom: clientInfo.firstName || "",
          email: clientInfo.email || "",
          emailConfirm: clientInfo.email || "",
          adresse: clientInfo.adressesFacturation?.street || "",
          complement1: clientInfo.adressesFacturation?.address2 || "",
          complement2: clientInfo.adressesFacturation?.address3 || "",
          codePostal: clientInfo.adressesFacturation?.postcode || "",
          ville: clientInfo.adressesFacturation?.city || "",
          pays: this.getCountryName(clientInfo.adressesFacturation?.countryCode) || "France",
          telephoneFixe: clientInfo.adressesFacturation?.phoneNumber || "",
          telephonePortable: clientInfo.adressesFacturation?.cellphone || clientInfo.phoneNumber || "",
          indicatifPhoneNumber: clientInfo.adressesFacturation?.indicatifPhoneNumber ? String(clientInfo.adressesFacturation.indicatifPhoneNumber).replace('+', '') : "33",
          indicatifCellphone: (clientInfo.indicatifCellphone || clientInfo.adressesFacturation?.indicatifCellphone) ? String(clientInfo.indicatifCellphone || clientInfo.adressesFacturation?.indicatifCellphone).replace('+', '') : "33",
        };
      }
    },
    getCountryName(countryCode) {
      return getCountryNameByCode(countryCode) || countryCode;
    },
    toggleEdit() {
      if (!this.registerStore.isEditingClient) {
        this.originalForm = JSON.parse(JSON.stringify(this.form));
      } else {
        this.form = JSON.parse(JSON.stringify(this.originalForm));
      }
      this.registerStore.toggleClientEdit();
    },
    getChangedFields() {
      const clientFields = ["civilite", "nom", "prenom", "email", "telephonePortable", "indicatifCellphone"];
      const addressFields = ["adresse", "complement1", "complement2", "codePostal", "ville", "pays", "telephoneFixe", "indicatifPhoneNumber", "telephonePortable", "indicatifCellphone"];

      const changedClientFields = clientFields.filter(field => this.form[field] !== this.originalForm[field]);

      const changedAddressFields = addressFields.filter(field => this.form[field] !== this.originalForm[field]);

      return {
        clientFields: changedClientFields,
        addressFields: changedAddressFields,
        hasClientChanges: changedClientFields.length > 0,
        hasAddressChanges: changedAddressFields.length > 0,
      };
    },
    async saveChanges() {
      if (!this.registerStore.isEditingClient) return;

      this.registerStore.error = null;

      if (this.form.email !== this.form.emailConfirm) {
        this.registerStore.error = "Les emails ne correspondent pas";
        return;
      }

      const changes = this.getChangedFields();

      if (!changes.hasClientChanges && !changes.hasAddressChanges) {
        this.registerStore.toggleClientEdit();
        return;
      }

      try {
        let clientData = null;
        if (changes.hasClientChanges) {
          clientData = {
            gender: this.form.civilite,
            lastName: this.form.nom,
            firstName: this.form.prenom,
            email: this.form.email,
            phoneNumber: this.form.telephonePortable,
            indicatifCellphone: this.form.indicatifCellphone,
          };
        }

        let addressData = null;
        if (changes.hasAddressChanges) {
          addressData = {
            firstName: this.form.prenom,
            lastName: this.form.nom,
            street: this.form.adresse,
            address2: this.form.complement1,
            address3: this.form.complement2,
            postcode: this.form.codePostal,
            city: this.form.ville,
            countryCode: this.getCountryCode(this.form.pays),
            phoneNumber: this.form.telephoneFixe,
            cellphone: this.form.telephonePortable,
            indicatifPhoneNumber: this.form.indicatifPhoneNumber,
            indicatifCellphone: this.form.indicatifCellphone,
          };
        }

        if (changes.hasClientChanges && changes.hasAddressChanges) {
          await this.registerStore.updateClientAndAddress(clientData, addressData);
        } else if (changes.hasClientChanges) {
          await this.registerStore.updateClientInfo(clientData);
        } else if (changes.hasAddressChanges) {
          await this.registerStore.updateClientAddress(addressData);
        }

        if (!this.registerStore.error) {
          this.mapApiDataToForm();
        }
      } catch (error) {
        console.error(error);
      }
    },
    getCountryCode(countryName) {
      const country = COUNTRIES.find(c => c.name === countryName);
      return country ? country.code : "FR";
    },
    openChangePasswordModal() {
      this.passwordForm = {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      };
      this.passwordError = null;
      this.showPasswordModal = true;
      document.body.classList.add("modal-open");
    },
    closeChangePasswordModal() {
      this.showPasswordModal = false;
      document.body.classList.remove("modal-open");
    },

    async changePassword() {
      const toast = useToast();

      this.passwordError = null;

      if (
        !this.passwordForm.currentPassword ||
        !this.passwordForm.newPassword ||
        !this.passwordForm.confirmPassword
      ) {
        toast.error("Tous les champs sont obligatoires");
        return;
      }
      if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
        toast.error("Les nouveaux mots de passe ne correspondent pas");
        return;
      }
      if (this.passwordForm.currentPassword === this.passwordForm.newPassword) {
        toast.error("Le nouveau mot de passe doit être différent de l'ancien");
        return;
      }
      if (this.passwordForm.newPassword.length < 6) {
        toast.error("Le nouveau mot de passe doit contenir au moins 6 caractères");
        return;
      }

      this.passwordLoading = true;
      try {
        const passwordData = {
          currentPassword: this.passwordForm.currentPassword,
          newPassword: this.passwordForm.newPassword,
          confirmNewPassword: this.passwordForm.confirmPassword,
        };

        const success = await this.registerStore.changeClientPassword(passwordData);

        if (success) {
          this.closeChangePasswordModal();
          this.passwordForm = {
            currentPassword: "",
            newPassword: "",
            confirmPassword: "",
          };
          toast.success("Mot de passe modifié avec succès");
        } else {
          const errorMessage = this.registerStore.error || "Erreur lors du changement de mot de passe";
          toast.error(errorMessage);
        }
      } catch (error) {
        console.error("Error changing password:", error);
        let errorMessage = "Erreur lors du changement de mot de passe";
        if (error.response?.data?.detail) {
          errorMessage = error.response.data.detail;
        } else if (error.message) {
          errorMessage = error.message;
        }
        toast.error(errorMessage);
      } finally {
        this.passwordLoading = false;
      }
    },

    // Méthodes pour le changement de vétérinaire
    openChangeVeterinarianModal() {
      this.veterinarianForm = {
        veterinaryCode: "",
        confirmChange: false
      };
      this.veterinarianError = null;
      this.veterinarianSuccess = null;
      this.showVeterinarianModal = true;
      document.body.classList.add("modal-open");
    },

    closeChangeVeterinarianModal() {
      this.showVeterinarianModal = false;
      document.body.classList.remove("modal-open");
    },

    async confirmChangeVeterinarian() {
      const toast = useToast();
      
      this.veterinarianError = null;
      this.veterinarianSuccess = null;

      if (!this.veterinarianForm.veterinaryCode.trim()) {
        this.veterinarianError = "Le code vétérinaire est obligatoire";
        return;
      }

      if (!this.veterinarianForm.confirmChange) {
        this.veterinarianError = "Veuillez confirmer que vous souhaitez changer votre vétérinaire";
        return;
      }

      this.veterinarianLoading = true;

      try {
        // Appel direct de la fonction depuis auth.js
        await changeVeterinarian(this.veterinarianForm.veterinaryCode.trim());
        
        this.veterinarianSuccess = "Vétérinaire changé avec succès";
        toast.success("Vétérinaire changé avec succès, vous allez être déconnecté(e) pour valider ce changement.");

        
        
        // Recharger les données du client pour afficher les nouvelles infos du vétérinaire
        setTimeout(async () => {
          await this.loadClientData();
          this.closeChangeVeterinarianModal();
        }, 1500);

        const authStore = useAuthStore();
        authStore.logout();

      } catch (error) {
        console.error('Error changing veterinarian:', error);

        let errorMessage = "Erreur lors du changement de vétérinaire";
        let errorDetails = null;

        if (error.response?.data) {
          const data = error.response.data;

          if (data.message) {
            errorMessage = data.message;
          } else if (data.msg) {
            errorMessage = data.msg; 
          } else if (data.detail) {
            errorMessage = data.detail;
          }
          errorDetails = data;
        } else if (error.message) {
          errorMessage = error.message;
        }

        if (errorMessage.includes("Code clinique erroné")) {
          errorMessage = "Le code clinique saisi est incorrect. Veuillez vérifier et réessayer.";
        }

        this.veterinarianError = errorMessage;
        toast.error(errorMessage, {
          description: errorDetails ? JSON.stringify(errorDetails) : undefined,
          duration: 6000,
        });

      } finally {
        this.veterinarianLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.min-w-200px {
  min-width: 200px;
}

.blue-color {
  color: #1e40af;
}

.font-18 {
  font-size: 18px;
}

.font-bold {
  font-weight: bold;
}

.info-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.info-list li {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.info-list li img {
  width: 18px;
  height: 18px;
  margin-right: 8px;
}

.modal-width {
  max-width: 500px;
}

.padd-modal {
  padding: 2rem;
}

.close-link {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6c757d;
  cursor: pointer;
}

.close-link:hover {
  color: #495057;
}

.btn-orange {
  background-color: #fd7e14;
  border-color: #fd7e14;
  color: white;
}

.btn-orange:hover {
  background-color: #e56c0c;
  border-color: #e56c0c;
}

.btn-outline-orange {
  border-color: #fd7e14;
  color: #fd7e14;
}

.btn-outline-orange:hover {
  background-color: #fd7e14;
  color: white;
}

.text-orange {
  color: #fd7e14;
}

.box-chart {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.form-input {
  margin-bottom: 1rem;
}

.label-control {
  font-weight: 500;
  margin-bottom: 0.5rem;
  display: block;
}

.input-form {
  flex: 1;
}

.input-group {
  display: flex;
  width: 100%;
  border: none !important;
}

.telephone-select {
  background-color: #e9ecef;
  border-right: none;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-color: #ced4da;
  max-width: 140px;
}

.telephone-select:focus {
  z-index: 2;
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.telephone-input {
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-color: #ced4da;
}

.telephone-input:focus {
  z-index: 2;
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

/* Ensure the border between them looks seamless or handled correctly */
.telephone-select:not(:focus) + .telephone-input:not(:focus) {
  border-left: 1px solid #ced4da; /* Restore border if needed, or keep it "none" for seamless look */
}


.form-check-input:checked {
  background-color: #fd7e14;
  border-color: #fd7e14;
}



.font-weight-bold {
  font-weight: 600;
}

.form-check {
    padding-left: 2rem;
}
</style>